export default __webpack_public_path__ + "static/media/book.ae1e41bf.svg";